module.exports = __webpack_public_path__ + "static/media/pic5.7c62a4af.jpg";